module.exports = __webpack_public_path__ + "15ccdf0e5e2deaa4b0f80f3e5460e7ce.svg";